import Spin from 'antd/lib/spin';
import List from 'antd/lib/list';
import React, { useState } from 'react';
import { Button } from 'antd';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import PromotionItem from './PromotionItem';

export default function PromotionUs() {
  const [showAddPromotionUs, setShowAddPromotionUs] = useState(false);
  const loading = useSelector(state => {
    return get(state, 'dealngon.loading', false);
  });
  const listPromotionUs = useSelector(state =>
    get(state, 'dealngon.promotionUs', [])
  );

  return (
    <Spin spinning={loading}>
      <div className="fragment-theme">
        <div className="btn-action">
          <div />
          <Button
            onClick={() => {
              return setShowAddPromotionUs(true);
            }}
            className="save"
          >
            <b>+ Khuyến mãi</b>
          </Button>
        </div>
      </div>
      <div className="dealngon-website">
        {showAddPromotionUs && (
          <PromotionItem isNew setShowAddPromotionUs={setShowAddPromotionUs} />
        )}
        {(listPromotionUs.length !== 0 || !showAddPromotionUs) && (
          <List
            split={false}
            dataSource={listPromotionUs}
            renderItem={({ _id, ...restProps }) => {
              return (
                <List.Item key={_id}>
                  <PromotionItem id={_id} {...restProps} />
                </List.Item>
              );
            }}
          />
        )}
      </div>
    </Spin>
  );
}
